import { render, staticRenderFns } from "./VTimeLineCorousel.vue?vue&type=template&id=4f934c62&scoped=true"
import script from "./VTimeLineCorousel.vue?vue&type=script&lang=ts"
export * from "./VTimeLineCorousel.vue?vue&type=script&lang=ts"
import style0 from "./VTimeLineCorousel.vue?vue&type=style&index=0&id=4f934c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f934c62",
  null
  
)

export default component.exports